module.exports = __webpack_public_path__ + "static/careers-apprentices-a2ae4b8c22d93c714879fa3d01664cf8.jpg";